// eslint-disable-next-line import/prefer-default-export
const REGULAR_SEGMENT = "REGULAR_SEGMENT";
const BREAK_SEGMENT = "BREAK_SEGMENT";
const TRANSFER_SEGMENT = "TRANSFER_SEGMENT";

export const ShiftSegmentTypeName = Object.freeze({
    [REGULAR_SEGMENT]: REGULAR_SEGMENT,
    [BREAK_SEGMENT]: BREAK_SEGMENT,
    [TRANSFER_SEGMENT]: TRANSFER_SEGMENT
});

export const ShiftSegmentType = Object.freeze({
    [REGULAR_SEGMENT]: 1,
    [TRANSFER_SEGMENT]: 3,
    [BREAK_SEGMENT]: 4
});
